import React from "react";
import "./CSS/customInput.css";
import { useThemeColors } from "../Context/Theme";

function CustomInput({
  type,
  label,
  value,
  onChange,
  isValid,
  className,
  placeholder,
  onKeyDown,
  validationMessage,
  required,
  name,
  children,
  style,
  onBlur,
  minLength,
  maxLength,
  width,
  height,
  marginTop,
  marginBottom,
  maxWidth,
  borderRadius,
  minWidth,
  border,
  backgroundColor,
  endIcon
}) {
    const {
      fontFamily,
      fontWeight,
      fontSize,
      fontFamilyHeading,
      fontWeightHeading,
      fontSizeHeading,
    } = useThemeColors();
    
  const inputId = `inputField-${name}`;
  return (
    <div
      data-mdb-input-init
      className="form-outline"
      style={{
        width: width || 0,
        backgroundColor: backgroundColor || "",
        minHeight: "10vh",
        width: "100%"
      }}
    >
      <label
        className="form-label"
        style={{ fontSize: fontSizeHeading || "14px", fontWeight: fontWeightHeading || "600", fontFamily: fontFamilyHeading}}
        htmlFor={inputId}
      >
        {label} {required && <span className="text-danger">*</span>}
      </label>
      {type === "select" ? (
        <select
          id={inputId}
          className={`form-control form-control-lg ${className}`}
          value={value}
          onChange={onChange}
          name={name}
          style={{ padding: "0px 0px", fontSize: fontSize || "1em", fontWeight, fontFamily }}
          onBlur={onBlur}
        >
          {children}
        </select>
      ) : (
        <div 
        style={{
          
          borderRadius: "10px",
          
          
          height:"48px",
          position: "relative",
          
        }}
        >
          <input
            type={type}
            id={inputId}
            name={name}
            className={`form-control form-control-lg ${className}`}
            value={value}
            onChange={onChange}
            onKeyDown={onKeyDown}
            placeholder={placeholder}
            style={{
              padding: endIcon? "0px 40px 0px 15px":"0px 15px",
              fontSize: fontSize || "0.8em",
              borderRadius: borderRadius || "10px",
              fontWeight: fontWeight || "400", 
              fontFamily,
              height:"100%",
              width:"100%",
              
              
              "::placeholder": { fontSize: fontSize || "3em", fontWeight: fontWeight || "500", fontFamily },
              ...style,
            }}
            onBlur={onBlur}
            minLength={minLength}
            maxLength={maxLength}
          />
          {endIcon && (
            <span style={{ position: "absolute", right: 10, top: "50%", transform: "translateY(-50%)", backgroundColor:"white" }}>
              {endIcon}
            </span>
          )}
        </div>
      )}
      {validationMessage && (
        <div className="invalid-feedback">{validationMessage}</div>
      )}
    </div>
  );
}

export default CustomInput;
